<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'QACenter',
            to: {
              name: 'QACenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'QACreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增問與答 -->
    <QACreateEdit></QACreateEdit>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACreateEdit from '@/views/G-3__QACategory/c/QACreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    QACreateEdit,
  },
  computed: {
    ...mapState('resqa', ['qa']),
  },
  created() {
    this.setQA({});
  },
  methods: {
    ...mapActions('resqa', ['setQA', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'QACenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.qa.question) {
          this.errors.push('問題 required.');
        } else if (!this.qa.faq_category_id) {
          this.errors.push('分類 required.');
        } else if (!this.qa.ans) {
          this.errors.push('答案 required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.qa).then(() => {
          this.$router.push({ name: 'QACenter' });
        });
      }
    },
  },
};
</script>
<style></style>
